import { buildJsonContractExample } from "./aiJsonContract";

export const buildBasePrompt = () => "";

export const buildOutputContract = (language) => {
  const example = buildJsonContractExample(language);

  return `## OUTPUT JSON SCHEMA
\`\`\`json
${JSON.stringify(example, null, 2)}
\`\`\`

Return exactly one JSON object matching this schema. If the available data cannot support the requested report, still return this same schema and explain the limitation in reportDescription, basicReportData, analysis, and recommendationsAndAlerts.`;
};
